import api from './api';

const apiWithTags = api.enhanceEndpoints({
	addTagTypes: ['FlexFacilityProfessionals']
});

const flexFacilityProfessionalsApi = apiWithTags.injectEndpoints({
	tagTypes: ['FlexFacilityProfessionals'],
	endpoints: (build) => ({
		flexFacilityProfessionals: build.query({
			query: ({ managementCompanyId, facilityId }) => ({
				url: `/flex/management-companies/${managementCompanyId}/facilities/${facilityId}/professionals`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['FlexFacilityProfessionals']
		}),
		updateFlexFacilityProfessionalsStatus: build.mutation({
			query: ({ managementCompanyId, facilityId, caregiverId, body }) => ({
				url: `/flex/management-companies/${managementCompanyId}/facility/${facilityId}/workforce/${caregiverId}/status`,
				method: 'PUT',
				body
			}),
			invalidatesTags: ['FlexFacilityProfessionals']
		}),
		BulkUpdateFlexFacilityProfessionalsStatus: build.mutation({
			query: ({ managementCompanyId, facilityId, body }) => ({
				url: `/flex/management-companies/${managementCompanyId}/facility/${facilityId}/workforce/status`,
				method: 'PUT',
				body
			}),
			invalidatesTags: ['FlexFacilityProfessionals']
		})
	})
});

export const {
	useFlexFacilityProfessionalsQuery,
	useUpdateFlexFacilityProfessionalsStatusMutation,
	useBulkUpdateFlexFacilityProfessionalsStatusMutation
} = flexFacilityProfessionalsApi;
